<template>
	<div class="place-dir qjc-relative">
		
		<ul class="list qjc-clearfix">
			<li class="travel qjc-fl qjc-relative">
				<van-swipe :autoplay="3000">
					<van-swipe-item v-for="image in travels" :key="image">
						<img v-lazy="require('@/assets/images/' + image)" @click="to('http://sydadonghaiyihao.vip.lechengol.com/')" />
					</van-swipe-item>
				</van-swipe>
				<h4 class="qjc-absolute qjc-wid-100 qjc-c-fff qjc-texta-c qjc-fts-30">度假村</h4>
			</li>
			<li class="cate qjc-fl qjc-relative">
				<h4 class="qjc-absolute qjc-wid-100 qjc-c-fff qjc-texta-c qjc-fts-30">美食</h4>
			</li>
			<li class="movie qjc-fl qjc-relative">
				<h4 class="qjc-absolute qjc-wid-100 qjc-c-fff qjc-texta-c qjc-fts-30">电影</h4>
			</li>
			<li class="shop qjc-fl qjc-relative">
				<h4 class="qjc-absolute qjc-wid-100 qjc-c-fff qjc-texta-c qjc-fts-30">购物</h4>
			</li>
			
			<!-- 月子中心 -->
			<li @click="to('https://mp.weixin.qq.com/s/YyrXinQIEaS6r1Q0WB-Rwg')" class="yuezizhongxin qjc-fl qjc-relative">
				<h4 class="qjc-absolute qjc-wid-100 qjc-c-fff qjc-texta-c qjc-fts-30">月子中心</h4>
			</li>
			
			
			<li class="hotel qjc-fl qjc-relative">
				<h4 class="qjc-absolute qjc-wid-100 qjc-c-fff qjc-texta-c qjc-fts-30">酒店</h4>
			</li>
			<li class="free qjc-fl qjc-relative">
				<h4 class="qjc-absolute qjc-wid-100 qjc-c-fff qjc-texta-c qjc-fts-30">休闲娱乐</h4>
			</li>
			
			<li class="fitness qjc-fl qjc-relative">
				<h4 class="qjc-absolute qjc-wid-100 qjc-c-fff qjc-texta-c qjc-fts-30">健身</h4>
			</li>
		</ul>
		
		<create-code></create-code>
		
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Swipe, SwipeItem, Lazyload } from 'vant'
	Vue.use(Swipe)
	   .use(SwipeItem)
	   .use(Lazyload);
	   
	import createCode from '@/components/createCode'
	
	export default{
		name: 'placeDir',
		data() {
			return {
				travels: [
					'travel1.png',
					'travel2.png',
					'travel3.png',
					'travel4.png',
					'travel5.png'
				]
			}
		},
		components: {
			createCode
		},
		methods: {
			// 跳转链接
			to(url) {
				window.location.href = url;
			}
		}
	}
</script>

<style scoped>
	.list >>> .van-swipe__indicators{
		bottom: 0.88rem;
	}
	.list >>> .van-swipe__indicator{
		width: 0.32rem;
		height: 0.04rem;
		background-color: rgba(0,0,0,.5);
		margin: 0 0.06rem;
		border-radius: 0.02rem;
		opacity: 1;
	}
	.list >>> .van-swipe__indicator--active{
		background-color: rgba(255,255,255,.5);
		opacity: 1;
	}
</style>
<style lang="scss" scoped>
	.place-dir{
		height: 9.9rem;
		background: url(https://meidn-image.oss-cn-beijing.aliyuncs.com/file/2020/home_bg.png) no-repeat;
		background-size: 100% 100%;
		padding-top: 0.48rem;
		
		.list{
			width: 18.02rem;
			margin: 0 auto;
			
			&>li{
				width: 4.22rem;
				height: 2.65rem;
				background-repeat: no-repeat;
				background-size: 100% 100%;
				margin: 0.12rem;
				border-bottom-left-radius: 0.08rem;
				border-bottom-right-radius: 0.08rem;
				overflow: hidden;
				
				h4{
					left: 0;
					bottom: 0;
					height: 0.72rem;
					line-height: 0.72rem;
					font-weight: 400;
					background-color: rgba(0,0,0,.6);
				}
				
				.van-swipe{
					img{
						width: 100%;
						height: 100%;
					}
				}
				
				&.yuezizhongxin{
					background-image: url(../../assets/images/yuezizhongxin.png);
				}
				&.travel{
					width: 8.68rem;
					height: 5.52rem;
					background-image: none;
					border-radius: 0.08rem;
				}
				&.cate{
					width: 4.22rem;
					height: 5.52rem;
					background-image: url(../../assets/images/cate.png);
				}
				&.movie{
					background-image: url(../../assets/images/movie.png);
				}
				&.shop{
					background-image: url(../../assets/images/shop.png);
				}
				&.hotel{
					background-image: url(../../assets/images/hotel.png);
				}
				&.free{
					background-image: url(../../assets/images/free.png);
				}
				&.fitness{
					background-image: url(../../assets/images/fitness.png);
				}
			}
		}
		
	}
</style>
